RivalIQ.apps.Admin.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.User = Backbone.Model.extend({
        urlRoot: '/admin/api/users',

        setPassword: function () {
            const me = this;

            const options = {
                url: `${me.url()}/password`
            };

            return (me.sync || Backbone.sync).call(me, 'update', me, options);
        },

        getAccount: function () {
            const me = this;
            return new models.Account(me.get('account'));
        }
    });
});
